module.exports = __webpack_public_path__ + "static/media/features-collect.0260eee7.png";